import { PaymentGatewayDashboard } from "@/components/accounting/PaymentGateway";
import { CreditCard } from "lucide-react";

export default function PaymentGatewaysPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold font-display text-foreground flex items-center gap-2">
          <CreditCard className="h-6 w-6 text-primary" /> Payment Gateways
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Connect Razorpay, Stripe & PayU — generate payment links, track collections, auto-record in books
        </p>
      </div>
      <PaymentGatewayDashboard />
    </div>
  );
}
